<template>
  <el-dialog :visible.sync="dialogVisible" width="1000px" :before-close="handleClose" class="chemicals-dialog">
    <div class="select-test-item" v-loading="loading">
      <div class="aside-test-items">
        <div class="header">添加测试项目</div>
        <div class="content">
          <div class="list-title">请选择您需要的项目：</div>
          <div class="level1-list">
            <div class="level1-tag" v-for="(item, index) in list" :key="index" @click="tagClick(item)" :class="{'is-active': currentData && item.categoryCode === currentData.categoryCode}">{{item.categoryName}}</div>
          </div>
          <template>
            <div class="list-title" v-if="currentData" style="margin-bottom: 7px;">请选择具体的测试项目：</div>
            <el-checkbox-group v-model="checkedIds" @change="checkedChange">
              <template v-for="item in list">
                <el-checkbox v-for="v in item.items" :key="v.itemId" :label="v.itemId" :class="{'is-hidden': !currentData || item.categoryCode !== currentData.categoryCode}">{{v.itemName}}</el-checkbox>
              </template>
            </el-checkbox-group>
          </template>
        </div>
      </div>
      <div class="aside-items-result">
        <div class="header">已选项目</div>
        <div class="checked-list">
          <template v-for="(item, index) in checkedDataList">
            <div class="checked-item" :key="index" v-if="item.itemId">
              <span class="checked-label">{{item.itemName}}</span>
              <span class="del-btn" @click="delItem(item)">删除</span>
            </div>
          </template>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleSubmit">确定</el-button>
          <el-button class="cancel-btn" @click="handleClose">取消</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ChooseChemicalsItem",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    apis: {
      type: Object,
      default: null
    },
    originalList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      currentData: null,
      loading: false,
      list: [],
      checkedIds: [],
      checkedDataList: [],
      currentIds: [],
      allById: {},
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
      },
      immediate: true
    },
    originalList: {
      handler(val) {
        this.checkedIds = []
        this.checkedDataList = JSON.parse(JSON.stringify(val))
        val.forEach(v => {
          if (v.itemId) {
            this.checkedIds.push(v.itemId)
          }
        })
        this.currentIds = [...this.checkedIds]
      },
      immediate: true
    }
  },
  created() {
    this.qryList()
  },
  methods: {
    checkedChange(val) {
      if (this.checkedDataList.length >= 20) {
        this.$message.error('测试项目数量已到上线')
        this.checkedIds = [...this.currentIds]
        return
      }
      this.checkedDataList = this.checkedDataList.filter(v => !v.itemId || val.includes(v.itemId))
      val.filter(v => {
        if (!this.currentIds.includes(v)) {
          let testItem = JSON.parse(JSON.stringify(this.allById[v]))
          testItem = Object.assign(testItem, {
            itemName: this.currentData.categoryName + ' ' + testItem.itemName,
            testMemo: '',
            isDetermine: 0,
            sampleNoList: [],
          })
          this.checkedDataList.push(testItem)
        }
      })
      this.currentIds = [...val]
    },
    qryList() {
      this.apis.qryBusinessItem({
        busiCode: 'CCL'
      }).then(res => {
        this.list = res.data
        res.data.forEach(v => {
          v.items.forEach(item => {
            this.allById[item.itemId] = item
          })
        })
      }).catch(e => {
        console.log(e);
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('input', false)
    },
    tagClick(data) {
      this.currentData = data
    },
    delItem(data) {
      this.checkedDataList = this.checkedDataList.filter(v => v !== data)
      this.checkedIds = this.checkedIds.filter(v => v !== data.itemId)
    },
    handleSubmit() {
      const keys = ['itemName', 'standardCode', 'testMemo', 'isDetermine']
      if(this.originalList.length === 1 && !(keys.some(v => this.originalList[0][v]) || this.originalList[0].sampleNoList.length)) {
        this.checkedDataList = this.checkedDataList.slice(1)
      }
      if (!this.checkedDataList.length) {
        this.checkedDataList.push({
          itemName: '',
          standardCode: '',
          testMemo: '',
          isDetermine: 0,
          sampleNoList: []
        })
      }
      this.$emit('update:originalList', this.checkedDataList)
      this.handleClose()
    }
  }
}
</script>

<style scoped lang="scss">
.chemicals-dialog {
  ::v-deep .el-dialog__headerbtn {
    z-index: 1;
  }
  ::v-deep .el-dialog {
    border-radius: 12px;
  }
  ::v-deep .el-dialog__header {
    padding: 0;
    border: none;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}
.select-test-item {
  display: flex;
  height: 700px;
  .aside-test-items {
    width: 700px;
    height: 100%;
    box-shadow: 5px 0px 15px 0px rgba(0, 0, 0, 0.05);
    .header {
      height: 55px;
      border-bottom: 1px solid #E7E7E7;
      padding-left: 30px;
      color: rgb(51, 51, 51);
      font-size: 16px;
      font-weight: 700;
      line-height: 54px;
    }
    .content {
      padding: 14px 30px 30px;
      height: 645px;
      overflow: auto;
    }
    .list-title {
      color: rgb(51, 51, 51);
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 14px;
    }
    .level1-list {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;
    }
    .level1-tag {
      border: 1px solid rgb(204, 203, 203);
      border-radius: 4px;
      height: 36px;
      color: rgb(51, 51, 51);
      font-size: 14px;
      line-height: 34px;
      padding: 0 14px;
      margin-right: 15px;
      margin-bottom: 15px;
      cursor: pointer;
      &.is-active {
        background: #CA4300;
        border-color: #CA4300;
        color: #fff;
      }
    }
    .el-checkbox.is-hidden {
      display: none;
    }
    ::v-deep .el-checkbox__label {
      line-height: 40px;
    }
  }
  .aside-items-result {
    height: 100%;
    width: 300px;
    position: relative;
    background: rgb(245, 245, 245);
    padding: 0 16px;
    border-radius: 0 12px 12px 0;
    .header {
      height: 55px;
      border-bottom: 1px solid #E7E7E7;
      padding-left: 16px;
      color: rgb(51, 51, 51);
      font-size: 16px;
      font-weight: 700;
      line-height: 54px;
    }
    .checked-list {
      height: 569px;
      overflow: auto;
    }
    .checked-item {
      color: #333333;
      font-size: 14px;
      line-height: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px;
      border-bottom: 1px dashed rgb(220, 220, 220);
      .del-btn {
        cursor: pointer;
        color: #CA4300;
        flex-shrink: 0;
        margin-left: 22px;
      }
    }
    .btns {
      position: absolute;
      height: 74px;
      display: flex;
      padding: 17px 35px 0;
      justify-content: space-between;
      border-top: 1px solid #E7E7E7;
      .el-button {
        width: 100px;
        height: 40px;
      }
      .cancel-btn {
        border-color: #CCCBCB;
        color: #878787;
      }
    }
  }
}
</style>